export default __webpack_public_path__ + "static/media/ear.ab40bddb.jpg";